import { render } from "./teacher-special.vue?vue&type=template&id=391044a9&scoped=true"
import script from "./teacher-special.vue?vue&type=script&lang=js"
export * from "./teacher-special.vue?vue&type=script&lang=js"

import "./teacher-special.vue?vue&type=style&index=0&id=391044a9&lang=scss&scoped=true"
import "./teacher-special.vue?vue&type=style&index=1&id=391044a9&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391044a9"]])

export default __exports__